require("!!/home/okkindel/Dokumenty/WEB/TanksGame/node_modules/script-loader/addScript.js")(require("!!/home/okkindel/Dokumenty/WEB/TanksGame/node_modules/raw-loader/index.js!/home/okkindel/Dokumenty/WEB/TanksGame/node_modules/phaser/build/custom/pixi.js"))


//////////////////
// WEBPACK FOOTER
// ./node_modules/phaser/build/custom/pixi.js
// module id = 48
// module chunks = 0